export const FeedbackTypeEnum = {
    like: 1,
    offensive: 2,
}

export const FeedbackTypeTextEnum = {
    like: 'Like',
    offensive: 'Offensive',
}